import { config } from './config';
import {
  getAfterDecimalCount,
  inRange,
  isNonEmptyStr,
  isTrueSet,
  matchesRegex,
  replaceValuesInCurlyBraces,
} from '../../helpers';
import store from '../../store';
import { init } from './phone-handle';

const { validationClasses, inputFieldsSelector } = config;
export const { container, error, valid, numberField, emailField, phoneField, passwordField, textField } =
  validationClasses;

let iti;

export const validate = () => {
  const inputFields = document.querySelectorAll(inputFieldsSelector);
  const inputPhone = document.querySelector('.js-phone');

  if (inputPhone) {
    iti = init(inputPhone);
    inputPhone.addEventListener('countrychange', () => setInputState(inputPhone));
  }

  inputFields.forEach(input => {
    setInputState(input, error, valid);
    input.dataset.valid = '';
    input.dataset.touched = false;

    input.addEventListener('change', inputEvent => {
      inputEvent.target.dataset.touched = true;
      setInputState(inputEvent.target);
    });

    input.addEventListener('input', inputEvent => {
      setInputState(inputEvent.target);
    });

    forbidSymbols(input);
  });

  const form = document.querySelector('form');

  form.addEventListener('submit', () => {
    triggerChange();
  });

  triggerChangeForPrefilledData();
};

export const isPasswordFormValid = () => {
  const inputFields = document.querySelectorAll(inputFieldsSelector);
  let isValidForm = true;

  inputFields.forEach(input => {
    if (input.type === 'password') {
      isValidForm = isValid.password(input);
    }
  });
  return isValidForm;
};

export const setInputState = inputField => {
  const inputType = inputField.dataset.content;

  if (isValid[inputType](inputField)) {
    inputField.dataset.valid = true;
  } else {
    inputField.dataset.valid = false;
  }

  if (isTrueSet(inputField.dataset.touched) && isTrueSet(inputField.dataset.valid)) {
    inputField.classList.add(valid);
    inputField.classList.remove(error);
    hideErrors(inputField);
  } else if (isTrueSet(inputField.dataset.touched) && !isTrueSet(inputField.dataset.valid)) {
    inputField.classList.add(error);
    inputField.classList.remove(valid);
    showError(inputField);
  } else {
    inputField.classList.remove(error);
    inputField.classList.remove(valid);
  }

  if (!isTrueSet(inputField.dataset.touched) && isTrueSet(inputField.dataset.backendError)) {
    inputField.classList.remove(valid);
    inputField.classList.add(error);
  }
};

export const setErrorMessage = {
  number: inputField => {
    const errorField = document.querySelector(`[name="${inputField.getAttribute('name')}"] + .${numberField}`);
    errorField.textContent = backEndVars.fieldRequired;
    errorField.textContent = getStatus(inputField).getMessage();
    return numberField;
  },
  email: inputField => {
    const errorField = document.querySelector(`.${emailField}`);
    const currentFieldValue = inputField.value;
    errorField.textContent = isNonEmptyStr(currentFieldValue) ? backEndVars.emailValid : backEndVars.emailRequired;
    return emailField;
  },
  text: inputField => {
    const errorField = document.querySelector(`[name="${inputField.getAttribute('name')}"] + .${textField}`);
    errorField.textContent = backEndVars.fieldRequired;
    const currentFieldValue = inputField.value;
    const minLength = inputField.minLength;

    if (currentFieldValue.length < minLength && currentFieldValue) {
      errorField.textContent = backEndVars.textMinSymbols.replace(/:length/g, minLength);
    }

    return textField;
  },
  password: inputField => {
    const errorFields = document.querySelectorAll(`.${passwordField}`);
    const currentFieldValue = inputField.value;
    const isPassConfirmField = inputField.id === 'password_confirmation';
    const minLength = inputField.minLength;

    if (isPassConfirmField) {
      errorFields[1].textContent = isNonEmptyStr(currentFieldValue)
        ? backEndVars.passwordMatch
        : backEndVars.passwordRequired;
    } else {
      errorFields[0].textContent = isNonEmptyStr(currentFieldValue)
        ? backEndVars.passwordMinChars.replace(/:min/g, minLength)
        : backEndVars.passwordRequired;
    }

    return passwordField;
  },
  tel: inputField => {
    const errorField = document.querySelector(`.${phoneField}`);
    errorField.textContent = backEndVars.phoneValid;

    if (!inputField.value) {
      errorField.textContent = backEndVars.fieldRequired;
    }

    return phoneField;
  },
};

export const isValid = {
  number: inputField => {
    const currentFieldValue = inputField.value;
    const minValue = Number(inputField.min);
    const maxValue = Number(inputField.max);

    if (!currentFieldValue && !inputField.required) {
      return true;
    }

    if (inputField.dataset.type) {
      return getStatus(inputField).isValid();
    }

    return inRange(currentFieldValue, minValue, maxValue);
  },
  email: inputField => {
    const currentFieldValue = inputField.value;
    const notRequiredEmpty = !isNonEmptyStr(currentFieldValue) && !inputField.required;
    if (notRequiredEmpty) {
      return true;
    }

    return isNonEmptyStr(currentFieldValue) && matchesRegex(currentFieldValue, config.regexExp.email);
  },
  text: inputField => {
    const currentFieldValue = inputField.value;
    const minlength = inputField.minLength;

    if (!currentFieldValue && !inputField.required) {
      return true;
    }

    return isNonEmptyStr(currentFieldValue) && currentFieldValue.length >= minlength;
  },
  password: inputField => {
    const currentFieldValue = inputField.value;
    const minLength = Number(inputField.minLength);
    const isMatch = document.querySelector('.js-password').value === inputField.value;

    if (!currentFieldValue && !inputField.required) {
      return true;
    }

    return isNonEmptyStr(currentFieldValue) && currentFieldValue.length >= minLength && isMatch;
  },
  tel: inputField => {
    if (iti.isValidNumberPrecise()) {
      const hiddenField = document.querySelector('#phone_country_code');
      store.set('__ph', iti.getNumber());
      hiddenField.value = iti.getSelectedCountryData().iso2;
    } else {
      store.set('__ph', null);
    }

    if (inputField.value === '' && !inputField.required) {
      return true;
    }

    toggleFlagContainerState();

    return iti.isValidNumberPrecise();
  },
};

const toggleFlagContainerState = () => {
  const flagContainer = document.querySelector('.iti__flag-container');

  if (flagContainer) {
    if (document.querySelector('.js-phone')) {
      const isNotValid = document.querySelector('.js-phone').classList.contains('a-input__input--error');
      isNotValid ? flagContainer.classList.add('error') : flagContainer.classList.remove('error');
    }
  }
};

export const showError = inputField => {
  document.querySelectorAll('.be-error').forEach(error => {
    error.textContent = '';
    error.classList.add('hidden');
  });
  const currentErrorSelector = setErrorMessage[inputField.dataset.content](inputField);
  const currentInputContainer = inputField.parentElement.classList.contains('iti')
    ? inputField.parentElement.parentElement
    : inputField.parentElement;
  const errorContainers = [...currentInputContainer.querySelectorAll('label' + container)];
  errorContainers.forEach(container => {
    container.classList.contains(currentErrorSelector)
      ? container.classList.remove('hidden')
      : container.classList.add('hidden');
  });
};

const hideErrors = inputField => {
  const currentInputContainer = inputField.parentElement.classList.contains('iti')
    ? inputField.parentElement.parentElement
    : inputField.parentElement;
  const errorContainers = [...currentInputContainer.querySelectorAll('label' + container)];
  errorContainers.forEach(container => !container.classList.contains('hidden') && container.classList.add('hidden'));
};

export const triggerChange = () => {
  const inputFields = [...document.querySelectorAll(inputFieldsSelector)].filter(f => f.offsetParent !== null);
  const event = new Event('change');
  inputFields.forEach(input => input.dispatchEvent(event));
};

function triggerChangeForPrefilledData() {
  // filters all fields that are visible, required and not prefilled with BE data;
  const inputFields = [...document.querySelectorAll(inputFieldsSelector)]
    .filter(f => f.offsetParent !== null)
    .filter(e => e.required && !e.classList.contains('js-phone'));
  const event = new Event('change');
  inputFields.forEach(input => input.value !== '' && input.dispatchEvent(event));
}

function getStatus(field) {
  const currentFieldValue = field.value;
  const maxValue = Number(field.max);
  const minValue = Number(field.min);
  const hasNoDecimal = !field.value.includes('.');
  const isDigit = parseInt(field.value) === +field.value && hasNoDecimal;
  const isEmpty = !currentFieldValue;
  const digitsAfterDecimal = getAfterDecimalCount(currentFieldValue);
  const isOnlyDigitsField = ['age', 'height_ft', 'height_inch'].includes(field.dataset.type);

  function isValid() {
    if (isOnlyDigitsField) {
      return currentFieldValue && inRange(+currentFieldValue, minValue, maxValue) && isDigit;
    }

    if (!isOnlyDigitsField) {
      return currentFieldValue && inRange(+currentFieldValue, minValue, maxValue) && digitsAfterDecimal <= 1;
    }
  }

  function getMessage() {
    if (isEmpty && field.required) {
      return backEndVars.fieldRequired;
    }

    if (!isOnlyDigitsField && digitsAfterDecimal > 1) {
      return backEndVars.numberDecimal;
    }

    if (isOnlyDigitsField && !isDigit) {
      return backEndVars.numberDigits;
    }

    if (currentFieldValue > maxValue) {
      return replaceValuesInCurlyBraces(backEndVars.numberMax.replace(/\n/g, ''), [field.max]);
    }

    if (currentFieldValue < minValue) {
      return replaceValuesInCurlyBraces(backEndVars.numberMin.replace(/\n/g, ''), [field.min]);
    }
  }

  return { isValid, getMessage };
}

export function handleTelKeydown(evt) {
  evt = evt || window.event;
  const char = evt.key;
  const isNotAllowed = !config.validTelKeys.includes(char);
  if (!new RegExp(/^\d*\.?\d*$/).test(char) && isNotAllowed) {
    evt.preventDefault();
  }
}

export function handleMeasurementsNumberKeydown(evt) {
  evt = evt || window.event;
  const char = evt.key;
  const isDigit = new RegExp(/\d/).test(char);
  const isValueDecimalEndingWithZero = new RegExp(/^\d*\.0$/).test(evt.target.value);

  // DEV NOTE: replaces .0 in a decimal value with the entered number
  if (isDigit && isValueDecimalEndingWithZero) {
    evt.target.value = +evt.target.value + +char / 10;
    evt.preventDefault();
    return;
  }

  const isValueInteger = new RegExp(/^\d+$/).test(evt.target.value);
  // DEV NOTE: prevents double click on decimal comma
  if (char === ',' && isValueInteger) {
    evt.target.value = parseFloat(evt.target.value).toFixed(1);
    evt.preventDefault();
    return;
  }

  const isNotAllowed = !config.validNumKeys.includes(char);
  // DEV NOTE: prevents double click on decimal period
  if (char === '.' && evt.target.value.includes('.')) {
    evt.preventDefault();
  }
  // DEV NOTE: prevents letters from being entered and digits are allowed
  if (!new RegExp(/^\d*\.?\d*$/).test(char) && isNotAllowed) {
    evt.preventDefault();
  }
}

export const forbidSymbols = input => {
  if (input.type === 'tel') {
    input.addEventListener('keydown', handleTelKeydown);
  }
  if (document.querySelector('form').classList.contains('measurements') && input.type === 'number') {
    input.addEventListener('keydown', handleMeasurementsNumberKeydown);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  validate();
});

window.triggerChange = triggerChange;
